module.exports = __webpack_public_path__ + "static/media/HomeRoll_Walls_BrkVeneerWall.92ac4e40.jpg";